var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOtherSocialIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 103,
    height: 103,
    viewBox: "0 0 103 103",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_6._Icon_arrow",
    "data-name": "6. Icon arrow",
    transform: "translate(-2142 -4516)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "trending_down_FILL0_wght200_GRAD0_opsz48",
    d: "M48.834,0V2.691H61.421L37.586,26.324,23.317,11.988,0,35.352,1.944,37.3,23.3,16.011,37.566,30.28,63.123,4.655v12.3h2.671V0Z",
    transform: "matrix(0.966, 0.259, -0.259, 0.966, 2166.153, 4540.5)",
    fill: "#4a86bc",
    stroke: "#538bbe",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_39",
    "data-name": "Ellipse 39",
    transform: "translate(2142 4516)",
    fill: "none",
    stroke: "#4a86bc",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 51.5,
    cy: 51.5,
    r: 51.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51.5,
    cy: 51.5,
    r: 49.5,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtherSocialIcon);
export default __webpack_public_path__ + "static/media/otherSocialIcon.d51d2941076de56fff8f4a872e26260d.svg";
export { ForwardRef as ReactComponent };